import grayLog from './graylog.js';

let instance_id = '';

export class EdgeConnection {

  constructor(ws_emitter) {
    this.ws_emitter = ws_emitter;
    this.pending = [];
    console.log('edgeConnection', this);
    this.hsm = null; // main chat hsm
    this.imHSMs = []; // instant messenger hsms
  }

  send(message) {
    console.warn('edgeConnection pending send', this, message);
    this.pending.push(message);
  }

  attach_transport() {
    while (this.pending.length) {
      let msg = this.pending.shift();
      console.log('send pending', msg);
      this.emit(msg);
    }
    this.send = (message) => this.emit(message);
  }

  emit(data) {
    this.connection.send(JSON.stringify(data));
    console.debug(instance_id + 'WS SEND >>> ', JSON.stringify(data));
  }

  close() {
    if (this.connection) {
      this.connection.onerror = null;
      this.connection.onclose = null;
      this.connection.onmessage = null;
      this.connection.onopen = null;
      this.connection.close()
    }
  }

  init_connection(connection_string) {
    console.info(instance_id + 'new WebSocket()', connection_string);
    grayLog.log('ws_new_connection');
    this.connection = new WebSocket(connection_string);
    this.connection.startDate = new Date();
    this.connection.onerror = this.onerror.bind(this);
    this.connection.onclose = this.onclose.bind(this);
    this.connection.onmessage = this.onmessage.bind(this);
    this.connection.onopen = this.onopen.bind(this);
  }

  onerror(event) {
    console.log(instance_id + 'WS onerror', event);
    clearInterval(this.presence_ping_interval);
    this.hsm.dispatch('ws_error', [event.toString()]);
  };

  onclose(event) {
    console.log(instance_id + 'WS onclose', event);
    clearInterval(this.presence_ping_interval);
    grayLog.log('ws_disconnected');
    this.hsm.dispatch('ws_closed', [event.toString()]);
  };

  onmessage(event) {
    let ws_msg = JSON.parse(event.data);
    // ws_msg['instance_id'] = instance_id;
    console.debug(instance_id + 'WS RECV <<<<', ws_msg);
    if (ws_msg.action) {
      //
      // if(ws_msg.action.startsWith('presence_')){
      //
      // }

      if (ws_msg.room && (ws_msg.room.indexOf('im_model_') !== -1 || ws_msg.room.indexOf('im_admin_') !== -1)) {
        // messenger
        const targetHSM = this.imHSMs.find(hsm => hsm.room === ws_msg.room);
        if (targetHSM) {
          targetHSM.dispatch(`sio_${ws_msg.action}`, [ws_msg]);
        } else {
          console.warn(instance_id + 'unknown messenger room', ws_msg)
        }
      } else {
        // chat
        this.hsm.dispatch(ws_msg.action,[ws_msg]);
      }

      this.ws_emitter.dispatch(ws_msg.action, ws_msg);
    } else {
      console.warn(instance_id + 'unknown message', ws_msg);
    }
  };

  start_presence_pings() {
    this.presence_ping_interval = setInterval(() => {
      this.emit({
        action: 'presence_ping'
      });
    }, 10 * 1000);
  }

  onopen(event) {
    console.log(instance_id + 'WS onopen', event);
    let ws_connection_time = (new Date() - this.connection.startDate) / 1000;
    ws_connection_time = Math.round(ws_connection_time * 100) / 100;
    grayLog.log('ws_connected', {ws_connection_time});
    this.hsm.dispatch('ws_connected', [event.toString()]);
    this.start_presence_pings();
    this.attach_transport();
  };

  /*
  websocket readyState
  0 CONNECTING Соединение ещё не открыто.
  1 OPEN Соединение открыто и готово к обмену данными.
  2 CLOSING Соединение в процессе закрытия.
  3 CLOSED Соединение закрыто или не может открыться.
  */
  is_connected_to(connection_string) {
    return this.connection
      && this.connection.url === connection_string
      && this.connection.readyState === 1;
  }

  connect_to(connection_string) {
    if (this.connection
      && this.connection.url === connection_string
      && this.connection.readyState === 0
    ) {
      console.log('already connecting to:', connection_string);
    } else {
      this.close();
      this.init_connection(connection_string);
    }
  }

  attach_hsm(hsm) {
    this.hsm = hsm;
  }

  attach_im_hsm(hsm) {
    this.imHSMs.push(hsm);
  }
}
